import React from 'react'
import AddInvoiceSection from '../../../component/billing-payments/invoice/AddInvoiceSection'

function AddInvoice() {
  return (
    <div className='page-body'>
         <AddInvoiceSection/>
    </div>
  )
}

export default AddInvoice
